module.exports = __webpack_public_path__ + "img/icon_4dajiazhiyoushi.39e12412.png";